





import { computed, defineComponent, PropType } from '@vue/composition-api';
import { CompanyLegalStatus } from '@/graphql';
import { companyLegalStatus } from '@/constants';

export default defineComponent({
  props: {
    legalStatus: {
      type: String as PropType<CompanyLegalStatus>,
      required: true,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    text: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const statusProps: { [key: string]: object } = Object.fromEntries(
      Object.entries(companyLegalStatus).map(([key, value]) => [
        key,
        {
          color: 'blue lighten-1',
          textColor: 'white',
          label: value,
        },
      ]),
    );

    return {
      state: computed(() => {
        return (
          statusProps[props.legalStatus] || {
            color: 'grey',
            textColor: 'white',
            label: props.legalStatus || 'Unbekannt',
          }
        );
      }),
    };
  },
});
